import { Component, OnInit } from '@angular/core';
import { UserManagementService } from 'src/app/user-management/shared/services/user-management.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  user : string;
  isMenuShow : boolean = true;
  constructor(public _authSvc : UserManagementService) { 
    // if(localStorage.getItem('userName')){
    //   this.user = localStorage.getItem('userName');
    // }
  }

  ngOnInit() {
    if(!this._authSvc.LoginUserName){
      this._authSvc.LoginUserName = localStorage.getItem('userName');
    }
  }
  logout(){
    this._authSvc.logout();
  }
  showHideMenu(){
    this.isMenuShow = !this.isMenuShow;
  }

  // activateClass(subModule: { active: boolean }) {
  //   this.subModules.forEach(element => {
  //     if (element.active=true){
       
  //     }
  //     else{
  //      active = false;
  //     }

      
  //   });
  //   subModule.active = !subModule.active;
  // }


}
